// extracted by mini-css-extract-plugin
module.exports = {"modalMainWrp":"style_modalMainWrp__3xWD3","modalBodyWrp":"style_modalBodyWrp__3u9f_"};